<nz-modal
    [(nzVisible)]="isVisible"
    [nzFooter]="null"
    [nzClosable]="false"
    (nzOnCancel)="close()"
    nzWidth="1200px">
    <div *nzModalContent>
        <app-task-detail
            [taskKey]="detail.taskKey"
            [fullscreen]="false"
            (closeEvent)="close()"
            (changeDetail)="changeDetail($event)"
            (changeSwimLane)="changeSwimLane($event)"
            (refreshStatus)="onRefreshStatus($event)"
        ></app-task-detail>
    </div>
</nz-modal>
